import SmartLockApiCallerInstance from '../utils/SmartLockApiCallerInstance';
import { SMART_LOCK_API_ENDPOINTS } from '../URLConstants';

export const GetAllRoutesData = async (page, search, filterBy) => {
  const response = await SmartLockApiCallerInstance.get(
    `${SMART_LOCK_API_ENDPOINTS.ROUTE_URL}?page=${page}&limit=10&search=${search}&sortField=${filterBy[0]}&sortOrder=${filterBy[1]}`
  );
  return response;
};

export const CreateNewRoute = async (data) => {
  const response = await SmartLockApiCallerInstance.post(SMART_LOCK_API_ENDPOINTS.ROUTE_URL, data);
  return response;
};
export const GetRouteDetailsById = async (id) => {
  const response = await SmartLockApiCallerInstance.get(
    `${SMART_LOCK_API_ENDPOINTS.ROUTE_URL}/${id}`
  );
  return response;
};
export const UpdteRouteDetailsById = async (id, data) => {
  const response = await SmartLockApiCallerInstance.patch(
    `${SMART_LOCK_API_ENDPOINTS.ROUTE_URL}/${id}`,
    data
  );
  return response;
};
export const DeleteRouteById = async (id) => {
  const response = await SmartLockApiCallerInstance.delete(
    `${SMART_LOCK_API_ENDPOINTS.ROUTE_URL}/${id}`
  );
  return response;
};

export const GetRouteList = async () => {
  const response = await SmartLockApiCallerInstance.get(
    `${SMART_LOCK_API_ENDPOINTS.ALL_ROUTE_DATA}`
  );
  return response;
};
